import { Skeleton } from "@mui/material";

export default function DataGridSkeleton({ rows = 5, height = "670px",isPadding=true }) {
  return (
    <div className="w-full gap-5 " style={{ height, padding: isPadding ?"1rem":'' }} >
      <Skeleton variant="rectangular" height={50} sx={{ mb: 1 }} style={{ borderRadius: "10px" }} className='gap-5 mb-7'/>
      {[...Array(rows)].map((_, rowIndex) => (
        <div key={rowIndex} className="flex gap-8 mb-7">
          {[...Array(4)].map((_, colIndex) => (
            <Skeleton  className='gap-10' variant="text" height={40}  width="100%" sx={{ flex: 1 }}  style={{ borderRadius: "10px" }} />
       ))}
        </div>
      ))}
    </div>
  );
}
